import { Components, createTheme, Theme } from "@mui/material/styles";

const baseTheme = createTheme();

const MuiInputLabel: Components<Theme>["MuiInputLabel"] = {
  styleOverrides: {
    root: {
      fontWeight: "bold",
      color: baseTheme.palette.text.primary,
    },
  },
};

export default MuiInputLabel;
